import firebase from '../../../../../../../firebase';
// eslint-disable-next-line

export const fieldChange = (appname, dataId, field, value) => {
  const dataRef = firebase
    .database()
    .ref(`apps/${appname}/draft/lazy_data/${dataId}`);

  dataRef.child(field).set(value);

  return {
    type: 'NOTIFICATION_FIELD_CHANGE',
    appname,
    dataId,
    field,
    value,
  };
};
